// extracted by mini-css-extract-plugin
module.exports = {"thumbsContainer":"style_thumbsContainer__1lepF","thumbInner":"style_thumbInner__1vM2S","thumbImage":"style_thumbImage__M7yl3","thumbImageRemove":"style_thumbImageRemove__2qho3"};